import * as e from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/CircleHalfTilt.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: i }));
o.displayName = "CircleHalfTiltIcon";
const f = o;
export {
  f as CircleHalfTilt,
  o as CircleHalfTiltIcon
};
